import { render, staticRenderFns } from "./IcoArrowInLeftRectangle.vue?vue&type=template&id=57cbb102"
import script from "./IcoArrowInLeftRectangle.vue?vue&type=script&lang=js"
export * from "./IcoArrowInLeftRectangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports